"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapKapiToDisplay = exports.dummyGasRegister = void 0;
var date_fns_tz_1 = require("date-fns-tz");
var __generated__1 = require("../../../../shared/api/kapi/v1/__generated__/");
var constants_1 = require("../../constants");
var utils_1 = require("../../utils");
var dummyMetersFromContracts_1 = require("./dummyMetersFromContracts");
var mapKapiReadings_1 = require("./mapKapiReadings");
var mapOmrReads_1 = require("./mapOmrReads");
var supplyStates_1 = require("./supplyStates");
var INVALID_DATE_ERROR = 'Invalid date';
exports.dummyGasRegister = {
    registerId: 'gas',
    timeOfUseLabel: null,
    startDate: constants_1.BACKUP_STARTDATE,
    endDate: null,
};
var validateStartDate = function (date) {
    var startDate = new Date(date);
    if (startDate.toString() === 'Invalid Date') {
        throw new Error(INVALID_DATE_ERROR);
    }
    return date;
};
//Assumes all registers on a meter have the same digits
var getMeterNumOfDigits = function (meterTechnicalDetail) {
    var _a;
    if (meterTechnicalDetail.registers.length > 0) {
        return parseInt((_a = meterTechnicalDetail.registers[0].numberOfDigits) !== null && _a !== void 0 ? _a : '0');
    }
    return 0;
};
var mapRegisters = function (meterTechnicalDetail, fuel, timezone) {
    return meterTechnicalDetail.registers.map(function (register) {
        return fuel === 'electricity'
            ? {
                registerId: register.registerId,
                timeOfUseLabel: (0, utils_1.timingCategoryToTimeOfUseLabel)(register.timingCategory),
                startDate: register.registerStartDate
                    ? (0, date_fns_tz_1.toZonedTime)(register.registerStartDate, timezone)
                    : constants_1.BACKUP_STARTDATE,
                endDate: register.registerEndDate
                    ? (0, date_fns_tz_1.toZonedTime)(register.registerEndDate, timezone)
                    : null,
            }
            : exports.dummyGasRegister;
    });
};
var mapKapiToDisplay = function (data, omrData, contractsTariffData) {
    var _a;
    var supplies = ((_a = data.account.accountSupplyPoints) !== null && _a !== void 0 ? _a : [])
        .map(function (asp) { return (__assign({}, asp)); })
        .flatMap(function (asp) {
        var _a, _b;
        var supplyPoint = asp.supplyPoint;
        var supplyPointInfo = {
            sprn: supplyPoint.sprn,
            timezone: supplyPoint.timezone,
            startDate: validateStartDate(asp.startDate),
            endDate: (_b = (_a = asp.end) === null || _a === void 0 ? void 0 : _a.date) !== null && _b !== void 0 ? _b : undefined,
            fuel: asp.supplyPoint.fuelType === __generated__1.SupplyFuel.Electricity
                ? 'electricity'
                : 'gas',
        };
        var meterInfos = asp.supplyPoint.meterTechnicalDetails.map(function (meterTechnicalDetail) {
            var _a;
            return ({
                msn: meterTechnicalDetail.meterSerialNumber,
                meterNumOfDigits: getMeterNumOfDigits(meterTechnicalDetail),
                rawMeterType: (_a = meterTechnicalDetail.type) !== null && _a !== void 0 ? _a : undefined,
                registers: mapRegisters(meterTechnicalDetail, supplyPointInfo.fuel, supplyPointInfo.timezone),
                meterStatus: meterTechnicalDetail.status
                    ? meterTechnicalDetail.status.toLowerCase()
                    : 'unknown',
            });
        });
        var reads = (0, mapKapiReadings_1.createValidMappedReads)(asp);
        //==== Merge in Opening Read Data ====//
        // If no active meters for supply
        // - Create one from Acquisition Contract data
        // - Add Opening Reads to this dummy meter
        // Else if an active meter is onboarding
        // - Add Opening Reads to the active meter
        var activeMeters = meterInfos.filter(function (meterInfo) { return meterInfo.meterStatus === 'active'; });
        if (activeMeters.length === 0) {
            var dummyMeter = (0, dummyMetersFromContracts_1.dummyMetersFromContracts)(contractsTariffData, supplyPoint.sprn, new Date(supplyPointInfo.startDate));
            meterInfos.push(dummyMeter);
            reads.push.apply(reads, __spreadArray([], __read((0, mapOmrReads_1.mapOmrReads)(omrData, asp.supplyPoint.sprn, dummyMeter)), false));
        }
        else {
            if ((0, utils_1.isOnboarding)(supplyPointInfo.startDate, activeMeters[0].msn)) {
                //Only insert OMRs if no reads already exist
                reads.length === 0 && reads.push.apply(reads, __spreadArray([], __read((0, mapOmrReads_1.mapOmrReads)(omrData, asp.supplyPoint.sprn, activeMeters[0])), false));
            }
        }
        return meterInfos.map(function (meterInfo) {
            var readsByMsn = reads.filter(function (read) { return read.msn === meterInfo.msn; });
            return __assign(__assign(__assign({}, supplyPointInfo), meterInfo), { states: (0, supplyStates_1.supplyStates)(meterInfo, supplyPointInfo, readsByMsn), readings: readsByMsn.sort(utils_1.mostRecentFirst) });
        });
    });
    //OVO only want to see active supplies and meters in the app
    var activeSupplyMeters = supplies.filter(function (supply) { return supply.states.isActive; });
    return mapToCombinedSupplies(activeSupplyMeters);
};
exports.mapKapiToDisplay = mapKapiToDisplay;
var mapToCombinedSupplies = function (activeSupplyMeters) {
    var gasSupplies = activeSupplyMeters.filter(function (supply) { return supply.fuel === 'gas'; });
    var elecSupplies = activeSupplyMeters.filter(function (supply) { return supply.fuel === 'electricity'; });
    var elecSuppliesWithMultipleSuppliesFlagged = (0, utils_1.hasComplexElec)(elecSupplies)
        ? elecSupplies.map(function (supply) { return (__assign(__assign({}, supply), { states: __assign(__assign({}, supply.states), { showSimplifiedLabels: false }) })); })
        : elecSupplies;
    return {
        electricity: elecSuppliesWithMultipleSuppliesFlagged,
        gas: gasSupplies,
    };
};
